import React from 'react';
import { Box, Typography, Button } from '@mui/material';

/**
 * Empty chart placeholder with optional action (design-review #52).
 */
const EmptyChartState = ({
    title = 'No chart data yet',
    description = 'Adjust filters or refresh when source data is available.',
    actionLabel = null,
    onAction = null,
    testId = 'empty-chart-state',
}) => (
    <Box
        data-testid={testId}
        sx={{
            py: 4,
            px: 2,
            textAlign: 'center',
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'background.default',
        }}
    >
        <Typography variant="subtitle1" gutterBottom>
            {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: actionLabel ? 2 : 0 }}>
            {description}
        </Typography>
        {actionLabel && onAction && (
            <Button variant="outlined" size="small" onClick={onAction}>
                {actionLabel}
            </Button>
        )}
    </Box>
);

export default EmptyChartState;
